import { AlertConfirm } from "../ConfirmationPopups";
import { GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import { GetLinearPageOptions, GetLinearPageOptionsWithParams, PageOptionParams } from "../Menus/PageSelectMenu";
import SelectDropdown from "../SelectDropdown";
import { AttributeFieldProps } from "./RenderAttributeInput";

export default function SimplePageSelectField({label,definition,layoutObject,updateFunc,screenSize,siteData,saveFunc}:AttributeFieldProps){

    const val = GetComponentOrStyleValueFromDefinition(definition,layoutObject,screenSize);
    let key = definition.attKey;

    const triggerChange = (val: string) => {
        updateFunc(key, val, definition.targetType);
        saveFunc();
      };

  
    let params = new PageOptionParams();
    params.duplicatedPagesOnly = true;
    params.excludeDisabled = true;

    let allOptions = GetLinearPageOptions(siteData);
    let options = GetLinearPageOptionsWithParams(siteData,params).sort((a,b)=>a.label.localeCompare(b.label));
    
    options.unshift({label:"Home Page",value:""});

    return( 
        <div className="wb-input-group flex-row">
            <label className={(val==""||val=="1")?"not-updated":"updated"} >{label}</label>
            <SelectDropdown
                key={"select-dropdown-" + key+layoutObject.id}
                options={options}
                defaultValue={val}
                allowFilter = {true}
                onChange={triggerChange}
                footer={ allOptions.length>options.length&&
                <button className="invisible-button" style={{color:"#267bc4"}}
                onClick={() => {

AlertConfirm(<div>
            <div>{"Only pages with the setting set to ‘Duplicate for All Locations’ will show up in this dropdown. "}</div>
            <br></br>
            <div>{"Go to any page settings and enable the toggle for ‘Duplicate for All Locations’ to be able to direct a location to that page. Check out our support article "}<a style={{textDecoration:"none"}} href="https://support.vagaro.com/hc/en-us/articles/26276358981147"  rel="noreferrer" target="_blank">learn more</a>.</div>
            </div>,undefined,"How to Add More Pages")

                }}
                >
                    Add More Pages
                </button>}
            />
        </div>
    );
}


// function OpenToDuplicatePageSetting(siteData:SiteData){
//     let sequence = [
//         new ClickSequenceItem(ClickSequenceEventType.Click,"#pages-tab"),
//         new ClickSequenceItem(ClickSequenceEventType.Click,"#"+siteData.homePageId+" button"),
//         new ClickSequenceItem(ClickSequenceEventType.ScrollTo,"#duplicate-all-option",50),
//         new ClickSequenceItem(ClickSequenceEventType.CircleFocus,"#duplicate-all-option .check-box-holder",500),
//         new ClickSequenceItem(ClickSequenceEventType.PulseGrow,"#duplicate-all-option .check-box-holder",500),
  
//     ]
//     ExecuteClickSequence(sequence);
// }